exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attribute-detail-list .attribute-filter[data-v-36f352fb]{display:inline-block;vertical-align:top;width:100%}", ""]);

// exports
